import React from 'react'
import gif from '../../images/JSUL.mp4'
import FormatPixel from '../utils/formatPixel'

export default function Reminder() {
  return (
    <>
    <a rel="noreferrer"  href='https://www.facebook.com/events/1036648550537107/?acontext=%7B%22ref%22%3A%2252%22%2C%22action_history%22%3A%22[%7B%5C%22surface%5C%22%3A%5C%22share_link%5C%22%2C%5C%22mechanism%5C%22%3A%5C%22share_link%5C%22%2C%5C%22extra_data%5C%22%3A%7B%5C%22invite_link_id%5C%22%3A650468952730650%7D%7D]%22%7D' target='_blank' className='flex justify-center mb-[225px] md:md-[250px] relative  md:flex md:flex-col'>
      <h5 className='large top-text uppercase md:relative md:translate-x-0 md:mb-[20px] z-20'>
        <FormatPixel text='Join' />
      </h5>
      <div className="relative w-full max-w-[700px] z-10">
            <div className="pt-[100%]">
              <video playsInline muted autoPlay loop className=" bg-image" src={gif} />
            </div>
          </div>
      <h5 className='large bottom-text uppercase md:relative  md:translate-x-0 md:mt-[20px] z-20'>
        <FormatPixel text='the Party' />
      </h5>
    </a>
   

    </>
  )
}
